import { Effect } from "../Materials/effect";
var name = 'layerVertexShader';
var shader = "\nattribute vec2 position;\n\nuniform vec2 scale;\nuniform vec2 offset;\nuniform mat4 textureMatrix;\n\nvarying vec2 vUV;\nconst vec2 madd=vec2(0.5,0.5);\nvoid main(void) {\nvec2 shiftedPosition=position*scale+offset;\nvUV=vec2(textureMatrix*vec4(shiftedPosition*madd+madd,1.0,0.0));\ngl_Position=vec4(shiftedPosition,0.0,1.0);\n}";
Effect.ShadersStore[name] = shader;
/** @hidden */
export var layerVertexShader = { name: name, shader: shader };
//# sourceMappingURL=layer.vertex.js.map